import React, { useEffect, useState } from 'react';
import MonthCalendarDays from './month-calendar-days';
import './../calendar.css';
import imgs from '../utils/images';
import WeekCalendarDays from './week-calendar-days';
import DayViewCalendar from './day-view-calendar';


const Calendar = ({ data }) => {
    const [appointments, setAppointments] = useState([{
        firstName: "",
        lastName: "",
        book_time: "",
        book_date: ""
    }]);
    const [viewMode, setViewMode] = useState('day'); // Default view mode is month
    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];

    const [currentDay, setCurrentDay] = useState(new Date());

    const changeCurrentDay = (day) => {
        setCurrentDay(new Date(day.year, day.month, day.number));
    };

    const nextDay = () => {
        setCurrentDay(prevDay => new Date(prevDay.setDate(prevDay.getDate() + 1)));
    };

    const previousDay = () => {
        setCurrentDay(prevDay => new Date(prevDay.setDate(prevDay.getDate() - 1)));
    };

    useEffect(() => {
        setAppointments(data);
    }, [data]);


    const changeViewMode = (mode) => {
        setViewMode(mode);
    };

    const renderCalendar = () => {
        switch (viewMode) {
            case 'month':
                return (
                    <div className="month-view mt-2">
                        <MonthCalendarDays day={currentDay} appointments={appointments} maxVisibleItems={2} changeCurrentDay={changeCurrentDay} changeViewMode={changeViewMode} />
                    </div>
                );
            case 'week':
                return (
                    <div className="week-view">
                        <WeekCalendarDays day={currentDay} appointments={appointments} changeCurrentDay={changeCurrentDay} />
                    </div>
                );
            case 'day':
                return (
                    <div className="day-view">
                        {/* Render Day View */}
                        <DayViewCalendar day={currentDay} appointments={appointments} changeCurrentDay={changeCurrentDay} />

                    </div>
                );
            default:
                return null;
        }
    };
    return (
        <div className="calendar">
            <div className="calendar-header">
                <div className="tools btn-group" role="group" aria-label="First group">
                    <button onClick={previousDay} className='btn btn-outline-secondary lh-1 px-0'>
                        <img src={imgs.prev} alt="prev" />
                    </button>
                    <p className='btn btn-outline-secondary lh-1 px-0'>{months[currentDay.getMonth()].substring(0, 3)} {currentDay.getDate()}</p>
                    <button onClick={nextDay} className='btn btn-outline-secondary lh-1 px-0'>
                        <img src={imgs.next} alt="next" />
                    </button>
                </div>
                <div className="title">
                    <p>{weekday[currentDay.getDay()]}, {currentDay.getDate()} {months[currentDay.getMonth()]} {currentDay.getFullYear()}</p>
                </div>
                <div>
                    <button className={`btn btn-outline-danger border-0  ${viewMode === 'day' ? 'active' : ''}`} onClick={() => changeViewMode('day')}>Day</button>
                    <button className={`btn btn-outline-danger border-0  ${viewMode === 'week' ? 'active' : ''}`} onClick={() => changeViewMode('week')}>Week</button>
                    <button className={`btn btn-outline-danger border-0  ${viewMode === 'month' ? 'active' : ''}`} onClick={() => changeViewMode('month')}>Month</button>

                </div>

            </div>
            <div className="calendar-body align-self-start">
                <div className="table-header">
                    {
                        weekdays.map((weekday, i) => {
                            return <div className="weekday" key={i}><p>{weekday}</p></div>
                        })
                    }
                </div>

                {renderCalendar()}
            </div>
        </div>
    );
};

export default Calendar;